import { isString, type AnyHTMLInputElementType } from "@mcwd/typescript-type-guards";

export type RawInputElementValue<T extends AnyHTMLInputElementType> =
  T extends HTMLInputElement
    ? string | number | null
    :
  T extends HTMLSelectElement
    ? string | string[]
    :
  T extends HTMLTextAreaElement
    ? (string | null)
    : never;

export function getRawInputElementValue<
  TInput extends AnyHTMLInputElementType
> (
  mktoInput: TInput
): RawInputElementValue<TInput>{
  type ThisReturnType = RawInputElementValue<TInput>;
  let val = $(mktoInput).val() ?? null;
  val = isString(val) && val.trim().length === 0 ? null : val;
  return val as ThisReturnType;
}
